const initialState = {
	isDragging: false
};

const dragNDropReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "IS_DRAGGING":
			state = {
				...state,
                isDragging: action.payload
			};
			break;
		default:
			return state;
	}
	return state;
};

export default dragNDropReducer;